import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Infoblock } from '@promo/const';
import { InfoblockService } from '@promo/feature';
import { SdvorGenericLinkComponent } from '@sdvor/shared/ui';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'sd-infoblock',
  imports: [AsyncPipe, SdvorGenericLinkComponent, SdvorIconComponent],
  templateUrl: './infoblock.component.html',
  styleUrls: ['./infoblock.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoblockComponent implements OnInit {
  infoblock$: Observable<Infoblock | null>;
  iconTypes = IconTypes;

  constructor(
    private infoblockService: InfoblockService,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.infoblockService.init();

    this.infoblock$ = this.infoblockService.infoblocks$.pipe(
      takeUntilDestroyed(this.destroyRef),
      map((infoblocks) => (infoblocks.length ? infoblocks[0] : null)),
    );
  }

  onClick(infoblock: Infoblock): void {
    this.infoblockService.visitedMarker(infoblock);
  }
}
